<template>
  <dx-grid
    :url="url"
    :columns="columns"
    :title="title"
    :actions="actions"
    :onRowClicked="onRowClicked"
    navigationPath="onRowClicked"
    navigationField="onRowClicked"
    :beforeSetupGrid="beforeSetupGrid"
    ref="grid"
    :summaryOptions="{
      enabled: true,
      columns: ['amount'],
    }"
    :expandedOptions="{
      enabled: true,
      allowExpandingAll: true,
      template: 'payment-details',
    }"
  ></dx-grid>
</template>

<script>
import { formatCurrency } from "../utils/helpers.js";

export default {
  data: () => ({
    title: "Payments",
    columns: [
      {
        field: "statusIcon",
        isIcon: true,
        template: "icon",
        alignment: "center",
        visible: true,
        allowFiltering: false,
        allowHeaderFiltering: false,
        allowHiding: false,
        allowSearch: false,
        cssClass: "width-25",
        headerFilter: {
          allowSearch: false,
          groupInterval: undefined,
          height: undefined,
          searchMode: "contains",
          width: undefined,
        },
        icon: (value) => {
          switch (value) {
            case "PROCESSED":
              return "mdi-check-circle";
            case "DECLINED":
              return "mdi-alert";
            case "SCHEDULED PAST DUE":
              return "mdi-alert-octagon";
            case "SCHEDULED":
              return "mdi-clock";
            case "VOIDED":
              return "mdi-cancel";
            case "ERROR":
              return "mdi-alert-circle";
            default:
              return "";
          }
        },
        iconColor: (value) => {
          switch (value) {
            case "PROCESSED":
              return "success";
            case "SCHEDULED":
              return "#fdb400";
            case "VOIDED":
              return "#aeb8bf";
            case "SCHEDULED PAST DUE":
            case "DECLINED":
            case "ERROR":
              return "#f35123";
            default:
              return "#aeb8bf";
          }
        },
      },
      {
        field: "name",
        label: "Name",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "accountID",
        label: "Account ID",
        format: "",
        template: "link-cell-template",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,

        link: (row) => {
          return row.categoryCode == "LAPD"
            ? "LapidusBillingView"
            : "LapidusAccountView";
        },
        showLink: (row) => {
          return true;
        },
      },
      {
        field: "date",
        label: "Transaction Date",
        type: "date",
        format: "",
        visible: true,
        filterType: "",
        format: "MM/dd/yyyy",
        sortOrder: "desc",
        sortIndex: 0,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "processedDate",
        label: "Processed Date",
        type: "date",
        format: "",
        visible: true,
        filterType: "",
        format: "MM/dd/yyyy hh:mm:ss a",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "dateCreated",
        label: "Date Created",
        type: "date",
        format: "",
        visible: true,
        filterType: "",
        format: "MM/dd/yyyy hh:mm:ss a",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "amount",
        label: "Amount",
        type: "number",
        format: {
          type: "currency",
          precision: 2,
        },
        precision: 3,
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "status",
        label: "Status",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "categoryDescription",
        label: "Category",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "receiptNumber",
        label: "Receipt Number",
        format: "",
        type: "number",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "bungalow",
        label: "Bungalow",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "byUser",
        label: "User",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "txnID",
        label: "Transaction ID",
        format: "",
        visible: false,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "paymentType",
        label: "PaymentType",
        format: "",
        visible: false,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "description",
        label: "Description",
        format: "",
        visible: false,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "paymentLogID",
        label: "Payment Log ID",
        format: "",
        type: "number",
        visible: false,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "scheduleDetailID",
        label: "Schedule Detail ID",
        format: "",
        type: "number",
        visible: false,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "note",
        label: "Note",
        format: "",
        visible: false,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "fromSchedule",
        label: "From Schedule",
        format: "",
        visible: false,
        filterType: "",
        type: "boolean",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "isImported",
        label: "Is Imported",
        format: "",
        visible: false,
        filterType: "",
        type: "boolean",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "cardType",
        label: "Card Type",
        format: "",
        visible: false,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "cardNumLast5",
        label: "Card Number Last5",
        format: "",
        visible: false,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "cardInfo",
        label: "Card Info",
        format: "",
        visible: false,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "transactionResult",
        label: "Transaction Result",
        format: "",
        visible: false,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "tranType",
        label: "Transaction Type",
        format: "",
        visible: false,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "authorizationCode",
        label: "Authorization Code",
        format: "",
        visible: false,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "sourceKey",
        label: "SourceKey",
        format: "",
        visible: false,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "isVoided",
        label: "Is Voided",
        format: "",
        visible: false,
        filterType: "",
        type: "boolean",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
    ],

    actions: [],

    regID: "",
    url: "",
  }),
  async created() {},
  methods: {
    async beforeSetupGrid() {
      await this.loadRegID();

      const terms = await this.getTerms();

      terms.sort((a, b) => b.term.localeCompare(a.term));

      this.actions.push({
        text: "Select Term",
        type: "select",
        values: terms.map((t) => t.term),
        value: this.regID,
        onSelected: this.onTermSelected,
      });

      this.url = "lapidusPayments?regID=" + this.regID;
    },
    async loadRegID() {
      this.regID = await this.$http.get("api/lapidusDayCamp/getRegID");
    },
    async getTerms() {
      return await this.$http.get("api/lapidusDayCamp/getRegTerms");
    },
    async onRowClicked(row) {
      if (row.categoryCode == "LAPD") {
        this.$router.push({
          name: "LapidusBillingView",
          params: { id: row.accountID, reg_id: row.regID },
        });
        return;
      }
      this.$router.push({
        name: "LapidusAccountView",
        params: { id: row.accountID, reg_id: row.regID },
        query: {
          isGirls: row.categoryCode == "LPDC",
        },
      });
    },
    onTermSelected(value) {
      this.regID = value;
      this.url = "lapidusPayments?regID=" + this.regID;

      this.$refs.grid.reloadDataSource(this.url);
    },
  },
};
</script>
<style>
[v-cloak] {
  display: none;
}
.v-btn__content {
  color: unset;
}
</style>
